export default __webpack_public_path__ + "static/nft-ab9597cb4591610f25d2bf8351dbf98b.gif";